import React, { useState } from 'react';
import moment from 'moment';
import * as Yup from 'yup';
import { Button, Col, Row } from 'react-bootstrap';
import { Field, getIn, Form, withFormik } from 'formik';
import { FormikRangePicker, FormikSelect, SimpleCenteredModal } from '../../components';
import FormikSelectClear from '../../components/Utils/Select/FormikSelectClear';
import abreviations from '../../assets/images/abbreviations.png';

const reportsOptions = ability => {
  const reports = [
    {
      action: 'index',
      resource: 'AttendanceReport',
      value: 'attendance-report',
      label: 'DT - Asistencia'
    },
    {
      action: 'index',
      resource: 'WorkdayReport',
      value: 'workday-report',
      label: 'DT - Jornada Diaria'
    },
    {
      action: 'export',
      resource: 'AttendanceDetailReport',
      value: 'attendance-detail-report',
      label: 'Detalle de Asistencia'
    },
    {
      action: 'export',
      resource: 'MissingTimeReport',
      value: 'missing-time-report',
      label: 'Tiempo Faltante'
    },
    {
      action: 'export',
      resource: 'OvertimeRecordReport',
      value: 'overtime-report',
      label: 'Tiempo Extra'
    },
    {
      action: 'export',
      resource: 'AttendanceSheetReport',
      value: 'attendance-sheet-report',
      label: 'Planilla de Asistencia'
    },
    {
      action: 'export',
      resource: 'AttendanceRecordReport',
      value: 'attendance-record-report',
      label: 'Registro de Asistencias'
    },
    { action: 'index', resource: 'SimpleReport', value: 'simple-report', label: 'Simple de Asistencia' },
    { action: 'index', resource: 'ShiftSummaryReport', value: 'shift-summary-report', label: 'Resumen de Turnos' },
    {
      action: 'export',
      resource: 'Marking',
      value: 'marking-report',
      label: 'Registro de Marca'
    }
  ];

  return reports
    .filter(report => ability.can(report.action, report.resource))
    .map(({ value, label }) => ({ value, label }));
};

const BossDashboardReportsSelector = ({
  ability,
  values,
  touched,
  errors,
  setFieldValue,
  setFieldTouched,
  isArial,
  employees,
  employeeIds,
  successFetchEmployee,
  isSubmitting
}) => {
  const reportOptions = reportsOptions(ability);
  const ALL_SELECTED_LABEL = 'Todos';
  const employeePlaceholder = successFetchEmployee ? 'Seleccione colaboradores' : 'Cargando colaboradores...';
  const [modalShow, setModalShow] = useState(false);
  const hasAllSelection = (groupSelection = []) => {
    return groupSelection.some(option => option.label === ALL_SELECTED_LABEL);
  };

  const handleNewMulti = (data, field, allowEmpty = false) => {
    let newData = data.map(element => element.value);
    if (allowEmpty && (!newData.length || hasAllSelection(data))) newData = employeeIds;
    setFieldValue(field, newData);
  };

  const handleDisabledSelection = (options, selectedOptions) => {
    if (hasAllSelection(selectedOptions)) {
      return true;
    }
    if (selectedOptions.length === 0) return false;
    return options.label === ALL_SELECTED_LABEL;
  };

  return (
    <>
      <Form className="reports_filter__overflow">
        <Row>
          <Col sm={12} md={12} xs={12}>
            <div className="mt-2 mb-1 justify-content-end d-flex">
              <Button className="arial-dt" variant="warning" onClick={() => setModalShow(true)}>
                Glosario de Abreviaciones
              </Button>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={3} xs={12}>
            <Field name="report_type">
              {({ field }) => (
                <FormikSelect
                  {...field}
                  abbr
                  label="Reportes"
                  options={reportOptions}
                  placeholder="Seleccione reporte"
                  onChange={data => {
                    setFieldValue(field.name, data || []);
                  }}
                  isClearable
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                  isArial={isArial}
                />
              )}
            </Field>
          </Col>
          <Col sm={12} md={4} xs={12}>
            <Field name="range_date_workday">
              {({ field }) => (
                <FormikRangePicker
                  {...field}
                  abbr
                  startDateName="date_from_workday"
                  endDateName="date_to_workday"
                  startDate={values.date_from_workday}
                  endDate={values.date_to_workday}
                  showClearDates
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                  isArial={isArial}
                  onDatesChange={({ startDate: startDateV, endDate: endDateV }) => {
                    const startValue = moment.isMoment(startDateV) ? startDateV.format('DD/MM/YYYY') : '';
                    const endValue = moment.isMoment(endDateV) ? endDateV.format('DD/MM/YYYY') : '';
                    setFieldValue('date_from_workday', startValue);
                    setFieldValue('date_to_workday', endValue);
                    setFieldTouched(field.name);
                    setFieldValue(field.name, [startValue, endValue]);
                  }}
                />
              )}
            </Field>
          </Col>
          <Col sm={12} md={3} xs={12}>
            <Field name="employees">
              {({ field }) => (
                <FormikSelectClear
                  {...field}
                  label="Nombres y Apellidos"
                  isMulti
                  options={employees}
                  placeholder={employeePlaceholder}
                  onChange={data => {
                    handleNewMulti(data || [], 'employee_ids', true);
                    setFieldValue(field.name, data || []);
                    setFieldValue('employee', '');
                    setFieldValue('employee_id', '');
                  }}
                  isOptionDisabled={handleDisabledSelection}
                  isClearable
                  error={getIn(errors, field.name)}
                  touched={getIn(touched, field.name)}
                />
              )}
            </Field>
          </Col>
          <Col md={2} className="mt-4">
            <Button
              className={`btn-block ellipsis ${isArial ? 'arial-dt' : ''}`}
              disabled={!successFetchEmployee || isSubmitting}
              type="submit"
              onClick={() => {
                setFieldValue('type', null);
              }}
            >
              Filtrar
            </Button>
          </Col>
        </Row>
      </Form>
      <SimpleCenteredModal
        title="Glosario de Abreviaciones"
        titleClass="modal-title-dt"
        body={
          <Row className="ml-2">
            <img src={abreviations} alt="Abreviaciones" style={{ maxWidth: '97%', height: 'auto' }} />
          </Row>
        }
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

const validationSchema = Yup.object().shape({
  range_date_workday: Yup.array().rangedate(true),
  report_type: Yup.mixed().required('Debes seleccionar un reporte')
});

const setInitialValues = () => {
  return {
    date_from_workday: '',
    date_to_workday: '',
    range_date_workday: [],
    employee_id: '',
    employee_ids: [],
    all_employee_ids: [],
    employees: [],
    report_type: null
  };
};

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;
  try {
    const res = formRequest(values, setSubmitting);
    if (res && typeof res.then === 'function') {
      return res.finally(() => setSubmitting(false));
    }
    setSubmitting(false);
    return null;
  } catch (err) {
    setSubmitting(false);
    throw err;
  }
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  validationSchema,
  handleSubmit,
  enableReinitialize: false
})(BossDashboardReportsSelector);
